import { render, staticRenderFns } from "./DialogProductGroup.vue?vue&type=template&id=0d81a1b0"
import script from "./DialogProductGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogProductGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports